import React, { FC, ReactNode } from 'react';

import { useIntl } from 'react-intl';

import EmptyState from 'components/empty-state';
import { NavigationAwareBackArrow } from 'components/navigation/back-arrow';
import { routes } from 'utils/routing';

import { messages } from './messages';
import { RecentOrderTitle, Wrap } from './styled';

interface IOrdersEmptyProps {
  children?: ReactNode;
}

const OrdersEmpty: FC<IOrdersEmptyProps> = ({ children }) => {
  const { formatMessage } = useIntl();
  return (
    <div>
      <NavigationAwareBackArrow color={Styles.color.headerContrast} />
      <RecentOrderTitle>{formatMessage(messages.recentOrders)}</RecentOrderTitle>
      {children}
      <Wrap>
        <EmptyState
          header={formatMessage(messages.noOrderYet)}
          subheader={formatMessage(messages.recentOrdersEmptySubHeader)}
          linkTo={routes.menu}
          linkText={formatMessage(messages.startOrder)}
        />
      </Wrap>
    </div>
  );
};

export default OrdersEmpty;
